import { defineStore } from "pinia";

export const generalStore = defineStore("general_store", {
    state: () => {
        return {
            active_login_form: "chat_login",
            form_options: null,
        };
    },
    getters: {
        get_active_login_form: (state) => state.active_login_form,
        get_form_options: (state) => state.form_options,
    },
    actions: {
        setActiveLoginForm(val, data = null) {
            this.$state.active_login_form = val;
            if (val == "re_verify" && data) {
                this.$state.form_options = data;
            } else if (val == "re_activate" && data) {
                this.$state.form_options = data;
            } else {
                this.$state.form_options = null;
            }
        },
    },
});
